<mat-paginator *ngIf="showPaginatorOnTop" [length]="totalEventsCount" [pageSize]="DEFAULT_PAGE_SIZE"
    [pageSizeOptions]="DEFAULT_PAGE_SIZE_OPTIONS" (page)="onPageChanged($event)" aria-label="Select page"
    [showFirstLastButtons]="true">
</mat-paginator>

<div class="events-list-container">
    <div *ngIf="isLoading" class="loading-spinner">
        <app-spinner></app-spinner>
    </div>

    <app-process-events-list *ngIf="!isLoading" [eventsList]="eventsList"
        [showParentType]="showParentType"></app-process-events-list>
</div>

<mat-paginator *ngIf="!showPaginatorOnTop" [length]="totalEventsCount" [pageSize]="DEFAULT_PAGE_SIZE"
    [pageSizeOptions]="DEFAULT_PAGE_SIZE_OPTIONS" (page)="onPageChanged($event)" aria-label="Select page"
    [showFirstLastButtons]="true">
</mat-paginator>